import { MetricKey } from "./keyedMetrics";
import { Media } from "./media";
import { Sentiment } from "./sentiment";

export class MetricType {
    static Engagement = new MetricType("Engagement", "https://www.talkwalker.com/app/page#/dashboard#g=DASHBOARD&i=cbd30d30-c77d-4ec9-9e70-167636e3a34a&tz=Europe%2FParis&cpid=DASHBOARD%21jc99ahml_5imm9ovou651&co=project&cid=ae049b7c-dc7d-4071-b785-14c92a2cb147");
    static Publications = new MetricType("Publications", "https://www.talkwalker.com/app/page#/dashboard#g=DASHBOARD&i=cbd30d30-c77d-4ec9-9e70-167636e3a34a&tz=Europe%2FParis&cpid=DASHBOARD%21jc99ahml_5imm9ovou651&co=project&cid=ae049b7c-dc7d-4071-b785-14c92a2cb147");
    static Media = new MetricType("Media", "https://www.talkwalker.com/app/page#/dashboard#g=DASHBOARD&i=41e1f81f-9ec9-4df1-b295-c6006bb0d17d&tz=Europe%2FParis&cpid=DASHBOARD%21jc9amlh0_5imm9ovouhhb&co=project&cid=ae049b7c-dc7d-4071-b785-14c92a2cb147", Media.AllMedias);
    static Sentiment = new MetricType("Sentiment", "https://www.talkwalker.com/app/page#/dashboard#g=DASHBOARD&i=f894f23c-069e-467e-b8da-9c8260fb5fc4&tz=Europe%2FParis&cpid=DASHBOARD%21jc9bab77_5imm9ovoumic&co=project&cid=ae049b7c-dc7d-4071-b785-14c92a2cb147", Sentiment.AllSentiments);
    static AllTypes = [MetricType.Engagement, MetricType.Publications, MetricType.Media, MetricType.Sentiment];

    private constructor(public name: string, public linkURL: string = "", public subMetricKeys: MetricKey[] = []) {
    }

    get hasSubMetrics(): boolean {
        return this.subMetricKeys.length > 0;
    }

    get jsonFilePath(): string {
        return `assets/app/metrics/${this.name.toLowerCase()}Metrics.json`;
    }

    get buttonPath(): string {
        return `assets/app/images/button-${this.name}_highlight.png`;
    }

    get deselectedButtonPath(): string {
        return `assets/app/images/button-${this.name}.png`;
    }

    toString(): string {
        return this.name;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/model/metricType.ts